<p-dialog [visible]="visibleSeletedDlg" [draggable]="false" [resizable]="false" appendTo="body" class="p-fluid"
          [modal]="true" [style]="{width: '50vw'}"
          (visibleChange)="visibleChangeDlg.emit($event)">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2" *ngIf="tramite">
            <i class="pi pi-tags text-blue-500 text-2xl"></i>
            <span class="font-bold text-xl md:text-2xl break-words">
                Justificar porque deseas agregar el trámite:  {{ tramite?.idTramite + ' - ' + tramite?.nombreTramite }} </span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="p-fluid">
            <div class="flex justify-content-center">
                <p-editor [(ngModel)]="comentarios" [style]="{ height: '367px',width: '45vw' }" (onTextChange)="emitTextChange()"
                          [placeholder]="'Ingresar comentario, razón, motivo o nota por el cual deseas agregar el trámite(s)'"  (onInit)="onEditorInit($event)">
                    <ng-template pTemplate="header">
                <span class="ql-formats">
                    <button type="button" class="ql-bold" aria-label="Bold"></button>
                    <button type="button" class="ql-italic" aria-label="Italic"></button>
                    <button type="button" class="ql-underline" aria-label="Underline"></button>
                    <button type="button" class="ql-strike" aria-label="Strikethrough"></button>
                    <button class="ql-image" type="button"></button>
                    <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                    <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                    <button type="button" class="ql-align" value="" aria-label="Align Left"></button>
                    <button type="button" class="ql-align" value="center" aria-label="Align Center"></button>
                    <button type="button" class="ql-align" value="right" aria-label="Align Right"></button>
                    <button type="button" class="ql-align" value="justify" aria-label="Justify"></button>

                </span>
                    </ng-template>
                </p-editor>
                <input #fileInput type="file" accept="image/*" style="display: none" (change)="onImagenSeleccionada($event)"/>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" class="p-button-text"
                icon="pi pi-times" (click)="cancel()"></button>

        <button pButton label="Si,agregar" icon="pi pi-check" [pTooltip]="'Seleccionar para agregar el trámite(s)'"
                (click)="confirm()" [disabled]="!this.eliminarTramiteService.textEditorValido()" [loading]="selecting"></button>
    </ng-template>
</p-dialog>

